/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  StandardError,
  TradeRoutes,
  TradeRoutesParams
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Trade routes list
 */
export const tradeRoutes = (
    params?: MaybeRefOrGetter<TradeRoutesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<TradeRoutes>(
      {url: `/trade-routes`, method: 'GET',
        params, signal
    },
      );
    }




export const getTradeRoutesQueryKey = (params?: MaybeRefOrGetter<TradeRoutesParams>,) => {
    return [
    'trade-routes', ...(params ? [params] : [])
    ] as const;
    }


export const getTradeRoutesQueryOptions = <TData = Awaited<ReturnType<typeof tradeRoutes>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<TradeRoutesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeRoutes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTradeRoutesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeRoutes>>> = ({ signal }) => tradeRoutes(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradeRoutes>>, TError, TData>
}

export type TradeRoutesQueryResult = NonNullable<Awaited<ReturnType<typeof tradeRoutes>>>
export type TradeRoutesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Trade routes list
 */

export function useTradeRoutes<TData = Awaited<ReturnType<typeof tradeRoutes>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<TradeRoutesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeRoutes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTradeRoutesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






